import script from "./RobotRecord.vue?vue&type=script&setup=true&lang=ts"
export * from "./RobotRecord.vue?vue&type=script&setup=true&lang=ts"

import "./RobotRecord.vue?vue&type=style&index=0&id=6d9be02a&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d9be02a"]])

export default __exports__